import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { setAuthenticationModalIsVisible } from '../../modules/Auth/authActions';
import MenuRewards from './components/MenuRewards';
import NotAuthRewards from './components/NotAuthRewards';
import { getOffers } from '../Offers/offersActions';
import { getLoyalty } from '../Loyalty/loyaltyActions';
import appConfig from '../../../app-config';
const MenuRewardsContainer = ({
  offers,
  isAuthenticated,
  isRequestingGetOffers,
  setAuthenticationModalIsVisible,
  currentPointsBalance,
  getOffers,
  getLoyalty,
}) => {
  useEffect(() => {
    if (isAuthenticated) {
      if (appConfig.isOffersEnabled) {
        getOffers();
      }
      if (appConfig.isLoyaltyEnabled) {
        getLoyalty();
      }
    }
  }, [isAuthenticated]);
  return (
    <div>
      {!isAuthenticated ? (
        <NotAuthRewards
          setAuthenticationModalIsVisible={setAuthenticationModalIsVisible}
        />
      ) : (
        !isRequestingGetOffers && (
          <MenuRewards
            offers={offers}
            isAuthenticated={isAuthenticated}
            currentPointsBalance={currentPointsBalance}
          />
        )
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  offers: state.offersReducer.offers,
  isRequestingGetOffers: state.offersReducer.isRequestingGetOffers,
  isAuthenticated: state.authReducer.isAuthenticated,
  currentPointsBalance:
    state.loyaltyReducer.loyalty &&
    state.loyaltyReducer.loyalty.loyalty_details.details.current_points_balance,
});

export default connect(mapStateToProps, {
  setAuthenticationModalIsVisible,
  getLoyalty,
  getOffers,
})(MenuRewardsContainer);
